import { Routes } from '@angular/router';
import { Layout } from './layout/layout';
import { authGuard } from './core/guards/auth.guard';
import { publicGuard } from './core/guards/public.guard';
import { Route } from './core/enums/route.enum';
import { subscriptionGuard } from './core/guards/subscription.guard';
import { PageNotFound } from './features/page-not-found/page-not-found';

export const routes: Routes = [
  {
    path: Route.AUTH,
    canActivate: [publicGuard],
    loadChildren: () =>
      import('./features/auth/auth.routes')
        .then(m => m.AUTH_ROUTES)
  },

  {
    path: '',
    component: Layout,
    canActivate: [authGuard, subscriptionGuard],
    children: [
      /**
       * 1. FIXED: Added a default redirect. 
       * Without this, navigating to "/" matches Layout but shows a blank screen 
       * because no child route is active.
       */
      {
        path: '',
        pathMatch: 'full',
        redirectTo: Route.INSIGHTS_CUBE
      },
      // {
      //   path: Route.DASHBOARD,
      //   loadChildren: () =>
      //     import('./features/dashboard/dashboard.routes')
      //       .then(m => m.DASHBOARD_ROUTES)
      // },
      {
        path: Route.INSIGHTS_CUBE, // Ensure your Enum string value matches your URL intent
        loadChildren: () =>
          import('./features/insights-cube/insight-cube.routes')
            .then(m => m.INSIGHTS_CUBE_ROUTES)
      },
      {
        path: Route.ASK_INSIGHT_PRO,
        loadChildren: () => 
          import('./features/ask-insights/ask-insights.routes').then(m=>m.ASK_INSIGHTS_ROUTE)
      },
      {
        path: Route.PROFILE,
        loadChildren: ()=> import('./features/profile/profile.route').then(m=>m.PROFILE_ROUTE)
      }
    ]
  },

  /**
   * 2. Wildcard: Redirects any unknown URL to root.
   * If authenticated, it hits the redirect above and lands on Dashboard.
   * If not authenticated, the authGuard will kick them to the Sign-in page.
   */
  {
    path: '**',
    loadComponent: () =>
    import(
      './features/page-not-found/page-not-found'
    ).then(
      m => m.PageNotFound
    )
  }
];